import { render, staticRenderFns } from "./ProjectsDrawer.vue?vue&type=template&id=3606d682"
import script from "./ProjectsDrawer.vue?vue&type=script&lang=js"
export * from "./ProjectsDrawer.vue?vue&type=script&lang=js"
import style0 from "./ProjectsDrawer.vue?vue&type=style&index=0&id=3606d682&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports